module.exports = __webpack_public_path__ + "static/img/drilling02.b9572ec9.png";